/**
 * Help §5.9 — Asking the AI to redo a document (`document/DocumentEditor.tsx`,
 * `document/GenerationStageView.tsx`).
 */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Callout, HelpSectionCard, Li, P, Shot, Steps } from '../HelpPrimitives.js';

export function Regenerate(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('regenerate')}>
      <Steps>
        <Li>
          Click <Btn>Regenerate</Btn>.
        </Li>
        <Li>
          In the <Btn>Regeneration instructions</Btn> field, describe what you want changed in plain
          English — the placeholder suggests{' '}
          <em>“e.g. make the tone more formal, regenerate the whole document in Chinese…”</em>.
        </Li>
        <Li>
          Click <Btn>Regenerate</Btn> to confirm; it shows <Btn>Regenerating…</Btn> while it works.
        </Li>
      </Steps>
      <Callout title="Writing good instructions">
        <P>
          Be specific — concrete instructions give better results than vague ones.{' '}
          <em>“Shorten to one page and add a sentence about the team culture”</em> works better than{' '}
          <em>“make it better”</em>.
        </P>
      </Callout>
      <Shot
        slug="regenerate"
        caption="The Regenerate dialog with the single Regeneration instructions field."
      />
      <Callout tone="change" title="Changed">
        There used to be two separate instruction fields (one per document, one general). There is
        now a single combined field.
      </Callout>
    </HelpSectionCard>
  );
}
